module.exports = __webpack_public_path__ + "img/DA_azul.9e717147.svg";